"use client"
import { useState, useEffect } from "react";
import SwiperComponent from "@/components/ui/swiper-component";
import { CategoryCard } from "@/components/CategoryCard";


export default function CategoryCollection({ model_data, storage_prefix_url }) {

    const categories = model_data?.children
    const slides = categories?.map((cat) => (
        <CategoryCard
            key={cat.id}
            item={cat}
            storage_prefix_url={storage_prefix_url}
        />
    ));

    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
    }, []);

    return (
        hydrated ?
            <SwiperComponent
                slides={slides}
                slidesPerView={3.5}
                spaceBetween={12}
                navigation={true}
                hideNavOnMobile={true}
                navPosition="sides"
                loop={false}
                breakpoints={{
                    400: { slidesPerView: 4.5, spaceBetween: 12 },
                    768: { slidesPerView: 6.5, spaceBetween: 20 },
                    868: { slidesPerView: 7.5, spaceBetween: 22 },
                    868: { slidesPerView: 8.5, spaceBetween: 22 },
                    968: { slidesPerView: 8.5, spaceBetween: 24 },
                    1100: { slidesPerView: 9.5, spaceBetween: 24 },
                    1200: { slidesPerView: 10.5, spaceBetween: 24 },

                }}
            />
            : <div className="flex gap-5 overflow-x-auto hide-scrollbar py-4">
                {categories?.map((cat, index) => (
                    <div key={index} className="shrink-0 w-[90px] lg:w-[110px]">
                        <CategoryCard
                            item={cat}
                            storage_prefix_url={storage_prefix_url}
                        />
                    </div>
                ))}
            </div>
    );
}
